import { zChargingStationCommonSchema } from "./chargingStation.common";
import { zDayjsSchema } from "@/types/zDayjs";
// ChargingStation Domain схема (расширяет базовую схему)
export const zChargingStationSchemaDom = zChargingStationCommonSchema
    .omit({
    manufactureDate: true,
    warrantyEndDate: true,
    lastMaintenanceDate: true,
    nextMaintenanceDate: true,
})
    .extend({
    manufactureDate: zDayjsSchema.nullish(),
    warrantyEndDate: zDayjsSchema.nullish(),
    lastMaintenanceDate: zDayjsSchema.nullish(),
    nextMaintenanceDate: zDayjsSchema.nullish(),
});
export const zChargingStationSchemaCreateDom = zChargingStationSchemaDom.omit({
    id: true,
});
